<template>
  <div id="user-hover" @click.stop="() => {}">

    <div class="main" v-if="User.peer">

      <!-- 状态 -->
      <div class="first-row">
        <div class="content">
          <div class="account" @click="goAccount">
            <div class="user-avatar"
              :style="`background-image: url(${User.peer && User.peer.logo ? User.peer.logo: 'https://o.666visa.cn/static/ssqpeer/homepage/icon-default-photo.png'})`"
            ></div>
            <div class="user-name">{{User.name? User.name : '个人中心'}}</div>
          </div>
          <div class="fill-space"></div>
          <div class="logout" @click="logout">退出</div>
        </div>

      </div>

      <!-- 管理员导航 -->
      <div class="admin-nav-row" @click="goCharge">
        <div class="content">
          <div class="user-nav-item">
            <div class="left-box">账户余额</div>
            <div class="right-box"><span class="price-icon">￥</span>{{User.peer && (User.peer.balance_amount / 100)}}</div>
          </div>
        </div>
      </div>

      <div class="admin-nav-row" @click="goCoupon">
        <div class="content">
          <div class="user-nav-item">
            <div class="left-box">优惠券</div>
            <div class="right-box">{{User.peer && User.peer.coupon_count}}张<span class="coupon-icon" v-if="User.peer && User.peer.show_coupon_tips"></span></div>
          </div>
        </div>

      </div>

      <!-- 充值 -->
      <div class="recharge-row">
        <a class="recharge-btn" target="_blank" @click="goCharge">
          <span class="text">立即充值</span>
          <!-- <span class="rate" v-if="maxRate">赠{{maxRate}}%</span> -->
          <div v-if="maxPresentCoupon">
            <span class="middle-line"></span>
            <span>最高赠{{maxPresentCoupon}}元券</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapMutations, mapState, mapActions } from 'vuex';
import {
  CLEAN_QRCODE,
  IS_LOGIN,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';
import User from '../../libs/user';

export default {
  name: 'user-hover',
  data() {
    return {
      User,
      maxPresentCoupon: 0,
    };
  },
  computed: {
    ...mapState('config', {
      maxRate(state) {
        return state.balance_config.max_rate ? state.balance_config.max_rate : 0;
      },
    }),
  },
  methods: {

    ...mapMutations('followOA', [
      CLEAN_QRCODE,
      IS_LOGIN,
    ]),

    ...mapActions('chargeActivity', [
      'getChargeActivity',
    ]),

    logout(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      User.logout();
      this.userMenu = false;
      window.location.reload();
      MtaH5.clickStat('nav0exit');
      // 退出清空qrcode 切换登录状态
      this.CLEAN_QRCODE();
      this.IS_LOGIN({ isLogin: 0 });
    },

    // 到商户设置
    goAccount(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      const { href } = this.$router.resolve({ name: 'balance' });
      window.open(href, '_blank');
    },

    // 到充值界面
    goCharge(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'balance' });
    },

    // 到优惠券界面
    goCoupon(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'coupon' });
    },
  },
  created() {
    this.getChargeActivity().then((data) => {

      // 充值赠送最高优惠券金额
      if (data && data.rules) {
        let maxData = data.rules[0].total_reduce;
        for (let i = 0; i < data.rules.length; i++) {
          if (data.rules[i].total_reduce > maxData) {
            maxData = data.rules[i].total_reduce;
          }
        }
        this.maxPresentCoupon = maxData / 100;
      }
    });
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable.less';
#user-hover {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow:0px 8px 12px 0px rgba(47,51,61,0.06);
  border: 1px solid #E9EEF2;
  width: 290px;
  line-height: normal;
  div.main {
    background-color: #ffffff;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      box-shadow: border-box;
      width: 15px;
      height: 15px;
      background: #fff;
      transform: translateX(-50%) rotate(45deg);
      transform-origin: center center;
      border-top: 1px solid #E9EEF2;
      border-left: 1px solid #E9EEF2;
      border-radius: 2px 0 0 0;
      z-index: 1;
    }
    div.first-row {
      padding: 0 16px;
      .content{
        padding: 16px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E9EEF2;
      }
      div.account {
        font-size: 14px;
        color: #2F333D;

        cursor: pointer;
        display: flex;
        align-items: center;
        flex-grow: 1;
        .user-name{
          flex-grow: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 180px;
        }
        div.user-avatar {
          flex-grow: 0;
          flex-shrink: 0;
          display: inline-block;
          background-size: 100% 100%;
          width: 16px;
          height: 16px;
          margin-right: 8px;
          border-radius: 50%;
        }
      }
      div.fill-space {
        flex: 1;
      }
      .logout {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #DEE2E6;
        color:#91999F;
        text-align: center;
        width: 52px;
        height: 24px;
        font-size: 12px;
        line-height: 1;
        cursor: pointer;
        border-radius: 12px;
        transition: all .1s;
        background: transparent;
        padding-left: 2px;
        &:hover {
          background-color: #599FFF;
          border: 1px solid #599FFF;
          color: white;
        }
      }
    }

    div.admin-nav-row {
      padding: 0 16px;
      transition: 0.2s all;
      &:hover{
        background: #F3F6F9;
      }
      .content{
        padding: 16px 0;
        padding-right: 16px;
        border-bottom: 1px solid #E9EEF2;
        display: flex;
        font-size: 14px;
        color: #2F333D;
        cursor: pointer;
        position: relative;
        &::after{
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          width: 12px;
          height: 12px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url('https://o.666visa.cn/static/ssqpeer/homepage/icon-right-gray-1.png');
        }
      }
      .user-nav-item{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left-box{
          color: #2F333D;
        }
        .right-box{
          font-size: 14px;
          color: #fc7906;
          display: flex;
          align-items: center;
          .price-icon{
            font-size: 12px;
          }
          .coupon-icon{
            margin-left: 10px;
            width: 45px;
            height: 13px;
            display: inline-block;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url('../../assets/imgs/index/expired.png')
          }
        }
      }
    }

    .recharge-row {
      width: 100%;
      padding: 16px;
      .recharge-btn{
        background: #FF8033;
        border-radius:4px;
        height: 36px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #fff;
        &:hover {
          opacity: 0.9;
        }
      }
      .rate{
        width: 50px;
        height: 18px;
        line-height: 18px;
        background-color: #fff5a1;
        display: inline-block;
        margin-left: 10px;
        color: #fc7906;
        text-align: center;
        font-size: 12px;
        border-radius: 4px;
        position: relative;
        &::before{
          content: '';
          width: 5px;
          height: 5px;
          background-color: #fff5a1;
          position: absolute;
          top: 50%;
          left: -3px;
          transform: translateY(-50%) rotate(45deg);
        }
      }
      .middle-line{
        display: inline-block;
        width: 1px;
        height: 12px;
        border: none;
        border-left: 1px solid #fff;
        margin: 0 10px;
        transform: translateY(1px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/user-hover.vue